const { useSearchParams } = require("react-router-dom");

const useFullScreen = (queryParam = "fullscreen") => {
  const [searchParams] = useSearchParams();
  const fs = searchParams.get(queryParam);
  return fs === "true" || fs === "1" || fs === true;
};

export default useFullScreen;
